let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("304BP")).then(() => parcelRequire('lMNKJ'));